<template>
    <v-app id="inspire">
        <navigation />
        <bar />
        <v-main class="app-shell">
            <v-container class="app-shell__container">
                <v-row>
                    <v-col>
                        <v-sheet rounded="lg" class="content-shell">
                            <router-view />
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script src="@/assets/js/index.js" />

<style scoped>
.app-shell {
  background: transparent;
}

.app-shell__container {
  padding-top: 28px;
  padding-bottom: 32px;
}

.content-shell {
  padding: 20px;
  border: 1px solid var(--pcse-border);
  background: rgba(255, 255, 255, 0.78);
  box-shadow: var(--pcse-shadow);
  backdrop-filter: blur(10px);
}

.content-shell :deep(.v-card) {
  border: 1px solid var(--pcse-border);
  box-shadow: 0 14px 34px rgba(13, 31, 46, 0.06);
}

.content-shell :deep(.v-table),
.content-shell :deep(.v-data-table) {
  border-radius: 18px;
  overflow: hidden;
}
</style>
